import { cn } from '@/lib/utils'

export type DocumentStatus = 'pending' | 'processing' | 'ready' | 'failed'

export interface DocumentHistoryItem {
  id: string
  title: string
  status: DocumentStatus
  detail: string
  updatedAt: string
}

export interface DocumentHistoryProps {
  items: DocumentHistoryItem[]
  className?: string
  onRefresh?: () => void
}

const statusStyles: Record<DocumentStatus, string> = {
  pending: 'text-foreground-muted',
  processing: 'text-primary',
  ready: 'text-primary',
  failed: 'text-red-500',
}

const statusLabels: Record<DocumentStatus, string> = {
  pending: 'En attente',
  processing: 'Traitement',
  ready: 'Terminé',
  failed: 'Erreur',
}

export default function DocumentHistory({ items, className, onRefresh }: DocumentHistoryProps) {
  return (
    <div className={cn('border border-border bg-surface p-5', className)}>
      <div className="flex items-center justify-between border-b border-border pb-3">
        <span className="text-sm font-mono text-foreground">Historique</span>
        <div className="flex items-center gap-3 text-xs font-mono text-foreground-muted">
          <span>{items.length} éléments</span>
          {onRefresh && (
            <button
              type="button"
              onClick={onRefresh}
              className="text-primary hover:underline"
            >
              Actualiser
            </button>
          )}
        </div>
      </div>
      <div className="mt-4 space-y-3 max-h-72 overflow-y-auto">
        {items.length === 0 ? (
          <p className="text-xs text-foreground-muted text-center py-4">Aucun document</p>
        ) : (
          items.map((item) => (
            <div key={item.id} className="border border-border bg-bg p-4">
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <p className="text-sm font-mono text-foreground truncate">{item.title}</p>
                  <div className="mt-2 flex items-center gap-2">
                    <span className={cn('text-xs font-mono', statusStyles[item.status])}>
                      {statusLabels[item.status]}
                    </span>
                    <span className="text-xs text-foreground-muted">-</span>
                    <span className="text-xs text-foreground-secondary">{item.detail}</span>
                  </div>
                </div>
                <span className="text-xs font-mono text-foreground-muted">{item.updatedAt}</span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  )
}
